export default __webpack_public_path__ + "static/media/icon-star.83dbaf97.svg";